/* eslint-disable no-nested-ternary */
import React, { ReactElement } from "react";

interface Props {
  cargo: string | null;
  isSuperintendente?: ReactElement<any, any>;
  isGerenteVendas?: ReactElement<any, any>;
  isCorretor?: ReactElement<any, any>;
  isGerenteGeral?: ReactElement<any, any>;
  isVendedor?: ReactElement<any, any>;
  isSupervisor?: ReactElement<any, any>;
  isEspecialistaProduto?: ReactElement<any, any>;
  isRecepcionista?: ReactElement<any, any>;
}

export function RenderByCargo(props: Props) {
  const SwitchRenderByCargo = (cargo: string | null) => {
    switch (cargo) {
      case "219.840.000":
        // Superintendente
        return <>{props.isSuperintendente} </>;
      case "219.840.001":
      case "219.840.013":
        // GerenteVendas
        return <>{props.isGerenteVendas}</>;
      case "219.840.002":
      case "219.840.012":
        // Corretor
        return <>{props.isCorretor} </>;
      case "219.840.003":
        // GerenteGeral
        return <>{props.isGerenteGeral} </>;
      case "219.840.004":
        // Vendedor
        return <>{props.isVendedor} </>;
      case "219.840.005":
        // Supervisor
        return <>{props.isSupervisor} </>;
      case "219.840.006":
        // EspecialistaProduto
        return <>{props.isEspecialistaProduto} </>;
      case "219.840.007":
        // Recepcionista
        return <>{props.isRecepcionista} </>;
      default:
        return <> </>;
    }
  };
  return <>{SwitchRenderByCargo(props.cargo)}</>;
}
